import { render } from "./alertDialog.vue?vue&type=template&id=1ce40c30&scoped=true"
import script from "./alertDialog.vue?vue&type=script&lang=js"
export * from "./alertDialog.vue?vue&type=script&lang=js"

import "./alertDialog.vue?vue&type=style&index=0&id=1ce40c30&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce40c30"]])

export default __exports__